module.exports = __webpack_public_path__ + "static/yuja-wang.f1798f8e.png";


//////////////////
// WEBPACK FOOTER
// /tmp/build_83f21ab6/src/assets/images/reviews/yuja-wang.png
// module id = 1213
// module chunks = 0 1 2 3